import React from "react";
import styled from "styled-components";
import get from "lodash/get";
import _ from "lodash";
import moment from "moment";
import includes from "lodash/includes";
import { VipIcon } from "./VipIcon";

const postMessage = (msg) => {
  const stringify = JSON.stringify(msg);
  window.postMessage(stringify, "*");
};

export const CommentHeader = ({
  commentList,
  onClick,
  clickVotes,
  isShare,
  isVoted,
  patientId,
  showModal,
}) => {
  const createdAt = get(commentList, "createdAt");
  const content = get(commentList, "content");
  const showState = get(commentList, "showState");
  const _id = get(commentList, "_id");
  const user = get(commentList, "user");
  const votes = get(commentList, "votes");
  const serviceIcon = get(commentList, "serviceIcon", {});
  let commentImage = get(commentList, "commentImage", "");

  if (commentImage && commentImage.length > 0) {
    commentImage = commentImage.replace(/http:/, "https:");
  }
  const tagInfo = {
    isMe: true,
    label: "自己发表",
  };
  const gotoAuthorPage = (authorId) => {
    if (authorId) {
      const players = document.querySelectorAll("video, audio");
      _.map(players, (player) => {
        player && player.pause();
      });
      postMessage({ type: "clickAuthorName", payload: { authorId } });
    }
  };
  return (
    <HeadContainer>
      <Root>
        <UserInfo>
          <InfoContainer>
            <Avatar
              style={{ width: 44, height: 44, backgroundColor: "pink" }}
              src={_.replace(user.avatar, "http:", "https:")}
              onClick={() => {
                gotoAuthorPage(get(user, "_id", ""));
              }}
            />
            <InfoPart>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Nickname>{user.petname || user.nickname}</Nickname>
                {/* <Tag>{'自己发表'}</Tag> */}
                <VipIcon
                  vipStatus={serviceIcon}
                  // style={{ marginTop: -3 }}
                  userId={get(user, "_id", "")}
                  patientId={patientId}
                />
              </div>
              <Time>{moment(createdAt).format("MM-DD HH:mm")}</Time>
            </InfoPart>
          </InfoContainer>
        </UserInfo>
        {showState === false ? null : (
          <div
            style={{ float: "right", display: "inherit" }}
            onClick={isShare ? () => {} : () => clickVotes(_id)}
          >
            <img
              src={require(`./images/${
                isVoted ? "icon_clap_green" : "icon_clap_dark"
              }.png`)}
              style={{
                width: "19px",
                height: "19px",
              }}
            />
            <div
              style={{ marginLeft: "4px", fontSize: 16, lineHeight: "19px" }}
            >
              {votes.length === 0 ? (
                <div style={{ color: "#999999", fontSize: 16 }}>点赞</div>
              ) : (
                <div style={{
                  fontFamily:'PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif'
                }}>
                  {includes(votes, patientId) ? (
                    <div style={{ color: "#26C5AB" }}>
                      {votes.length > 99 ? "99+" : votes.length}
                    </div>
                  ) : (
                    <div style={{ color: "#999999", fontSize: 16 }}>
                      {votes.length > 99 ? "99+" : votes.length}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </Root>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <div
          style={{
            width: 52,
            flexShrink: 0,
          }}
        ></div>
        {showState === false ? (
          <div
            style={{
              height: 30,
              color: "#999999",
              fontSize: 16,
            }}
          >
            该评论已经被删除
          </div>
        ) : (
          <RootView
            onClick={isShare ? () => {} : () => onClick(user, _id, "first")}
          >
            <span
              style={{
                whiteSpace: "pre-wrap",
                color: "#333",
                fontSize: "15px",
                lineHeight: "24px",
              }}
            >
              {content && content.trim().replace(/(\s){2,}/g, "$1")}
            </span>

            {commentImage ? (
              <div style={{ flex: 1 }}>
                <img
                  src={commentImage}
                  style={{
                    height: 135,
                    width: 135,
                    marginTop: 10,
                    marginBottom: 8,
                    borderRadius: 4,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    showModal(commentImage, "commentType");
                  }}
                />
              </div>
            ) : null}
          </RootView>
        )}
      </div>
    </HeadContainer>
  );
};

const Root = styled.div`
  display: flex;
  justify-content: space-between;
`;
const RootView = styled.div`
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  margin-top: 8px;
  line-height: 24px;
  flex-grow: 1;
  padding-bottom: 10px;
  border-bottom: 1px solid #f5f6f8;
`;
const HeadContainer = styled.div`
  position: relative;
  padding: 12px 0px 0px 0px;
  background: #fff;
`;
const UserInfo = styled.div`
  display: flex;
`;

const InfoContainer = styled.div`
  display: flex;
`;

const Avatar = styled.img`
  height: 44px;
  width: 44px;
  border-radius: 44px;
`;

const InfoPart = styled.div`
  margin-left: 10px;
  display: flex;
  font-size:13px
  flex-direction: column;
  justify-content: space-between;
`;

const Nickname = styled.span`
  font-size: 15px;
  color: #333333;
  line-height: 20px;
  font-family: PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif;
`;

const Tag = styled.span`
  margin-left: 5px;
  background: #eee;
  display: inline-block;
  padding: 1px;
  border-radius: 5px;
  color: #999;
  margin-left: 8px;
  font-size: 12px;
`;

const Time = styled.div`
  font-size: 13px;
  color: #999;
  line-height: 20px;
  font-family: PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif;
`;
const BtnContainer = styled.div`
  color: blue;
  background-color: red;
`;



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/CommentHeader.js